import $x from '@/utils/$x';

/**
 * 查询动作库列表
 * @param {*} params
 * @returns
 */
export async function getActionList(params) {
  return $x.post('/action/list', params);
}

/**
 * 查询动作详情
 * @param {*} params
 * @returns
 */
export async function getActionDetail(params) {
  return $x.post('/action/detail', params);
}

/**
 * 上下架 动作
 * @param {*} params
 * @returns
 */
export async function operateAction(params) {
  return $x.post('/action/operate', params);
}

/**
 * 修改动作
 * @param {*} params
 * @returns
 */
export async function modifyAction(params) {
  return $x.post('/action/modify', params);
}

/**
 * 新增动作
 * @param {*} params
 * @returns
 */
export async function addAction(params) {
  return $x.post('/action/add', params);
}

/**
 * 动作分类
 * @param {*} params
 * @returns
 */
export async function getActionClass(params) {
  return $x.post('/action/actionClass', params);
}

//  获取动作库白名单
export async function getActionWhiteList() {
  return $x.post('/action/externalGrant', { requestData: {} });
}
/**
 * 禁用列表
 * @param {*} params
 * @returns
 */
export async function getForbidList(params) {
  return $x.post('/actionForbid/list', params);
}

/**
 * 新建禁用
 * @param {*} params
 * @returns
 */
export async function addForbid(params) {
  return $x.post('/actionForbid/add', params);
}

/**
 * 修改
 * @param {*} params
 * @returns
 */
export async function modifyForbid(params) {
  return $x.post('/actionForbid/modify', params);
}

/**
 * 操作
 * @param {*} params
 * @returns
 */
export async function operateForbid(params) {
  return $x.post('/actionForbid/operate', params);
}

/**
 * 操作
 * @param {*} params
 * @returns
 */
export async function operateLog(params) {
  return $x.post('/action/operateLog', params);
}

/**
 * action条件
 * @param {*} params
 * @returns
 */
export async function actionLabel(params) {
  return $x.post('/action/actionLabel', params);
}

/**
 * 弹窗查询动作
 * @param {*} params
 * @returns
 */
export async function getActionListByRelType(params) {
  return $x.post('/action/getActionListByRelType', params);
}

/**
 * 获取功能维度枚举
 * @param {*} params
 * @returns
 */
export async function getActionImproveLabel(params) {
  return $x.post('/action/getActionImproveLabel', params);
}

/**
 * 查询用户动作视频列表
 * @param {*} params
 * @returns
 */
export async function getUserActionList(params) {
  return $x.post('/class/comment/order/list', params);
}

/**
 * 查询教练 支持按照教练姓名/花名模糊搜索
 * @param {*} params
 * @returns
 */
export async function queryCoach(params) {
  return $x.post('/common/queryCoach', params);
}

/**
 * 查询教练 查询动作-问题点模型
 * @param {*} params
 * @returns
 */
export async function getProblemPointsForComment(params) {
  return $x.post('/class/comment/order/getProblemPointsForComment', params);
}

/**
 * 修改点评
 * @param {*} params
 * @returns
 */
export async function modifyComment(params) {
  return $x.post('/class/comment/order/modifyComment', params);
}

/**
 * 特色课-部位枚举
 * @param {*} params
 * @returns
 */
export async function optionalParts(params) {
  return $x.post('/specialcourse/optionalParts', params);
}
/**
 * 特色课- 特色课程列表
 * @param {*} params
 * @returns
 */
export async function specialCourseList(params) {
  return $x.post('/specialcourse/list', params);
}
/**
 * 特色课- 特色课程列表
 * @param {*} params
 * @returns
 */
export async function specialCourseDetail(params) {
  return $x.post('/specialcourse/detail', params);
}
/**
 * 特色课- 精选or取消精选
 * @param {*} params
 * @returns
 */
export async function specialCarefulChoose(params) {
  return $x.post('/specialcourse/carefulChoose', params);
}
/**
 * 专属计划
 * @param {*} params
 * @returns
 */
export async function exclusiveProgramList(params) {
  return $x.post('/specialcourse/listPlan', params);
}
/**
 * 专属计划
 * @param {*} params
 * @returns
 */
export async function exclusiveProgramDetail(params) {
  return $x.post('/specialcourse/detailPlan', params);
}

/**
 * 课程海报
 * @param {*} params
 * @returns
 */
export async function getCoursePoster(params) {
  return $x.post('/specialcourse/getCoursePoster', params);
}

/**
 * 课程海报
 * @param {*} params
 * @returns
 */
export async function getPlanPoster(params) {
  return $x.post('/specialcourse/getPlanPoster', params);
}
/**
 * 导入专属计划
 * @param {*} params
 * @returns
 */
export async function importExclusivePlan(params) {
  return $x.post('/weekplan/import', params);
}
/**
 * action上下架
 * @param {*} params
 * @returns
 */
export async function actionShelf(params) {
  return $x.post('/action/shelf', params);
}
/**
 * 知识列表
 * @param {*} params
 * @returns
 */
export async function getKnowledgeList(params) {
  return $x.post('/knowledge/list', params);
}

/**
 * 上下架知识
 * @param {*} params
 * @returns
 */
export async function upOrDownKnowledge(params) {
  return $x.post('/knowledge/upOrDown', params);
}
/**
 * 删除知识
 * @param {*} params
 * @returns
 */
export async function delKnowledge(params) {
  return $x.post('/knowledge/del', params);
}
